/**
 * Ayudas del inicio de sesión con código.
 *
 * Reenvío: espera entre envíos y el mismo tope por ventana que aplica el servidor
 * (apps/api/src/auth/otp.ts), que responde igual aunque no envíe para no revelar nada.
 * Aquí solo se avisa antes; el límite real sigue en el servidor.
 */
export const RESEND_WAIT_MS = 60_000;
export const CODES_PER_WINDOW = 3;
export const CODE_WINDOW_MS = 15 * 60_000;

/** Los 6 dígitos de un texto pegado («123 456», «Tu código es 123456»…), o null. */
export function codeFromPaste(raw: string): string | null {
  // Seis dígitos seguidos o separados por un espacio o guion, sin más dígitos pegados.
  const found = raw.match(/(?<!\d)\d(?:[ -]?\d){5}(?!\d)/);
  return found ? found[0].replace(/\D/g, '') : null;
}

/** Cuándo se puede pedir otro código según los envíos hechos en esta pantalla. */
export function nextResendAt(sentAt: number[], now: number): { at: number; capped: boolean } {
  const recent = sentAt.filter((s) => now - s < CODE_WINDOW_MS);
  if (recent.length >= CODES_PER_WINDOW) return { at: Math.min(...recent) + CODE_WINDOW_MS, capped: true };
  return { at: (sentAt.length ? Math.max(...sentAt) : 0) + RESEND_WAIT_MS, capped: false };
}
